export default __webpack_public_path__ + "static/media/darius_x_wayne_snow_lowdef.42049d28.png";